import React from "react";
import PropTypes from "prop-types";

const Union = ({ svgId }) => {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id={svgId}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.89905 5.9934C3.14495 7.29953 3.59247 8.96968 4.8986 9.72378L6.08108 10.4065L5.39833 11.589C4.64423 12.8952 5.09175 14.5653 6.39788 15.3194C7.70401 16.0735 9.37416 15.626 10.1283 14.3199L10.811 13.1373L11.9935 13.82C13.2996 14.5741 14.9698 14.1266 15.7239 12.8205C16.478 11.5143 16.0304 9.84418 14.7243 9.09008L13.5418 8.40738L14.2245 7.22497C14.9786 5.91884 14.5311 4.24869 13.2249 3.49459C11.9188 2.7405 10.2487 3.18801 9.49456 4.49415L8.8119 5.67655L7.62943 4.99385C6.32329 4.23975 4.65314 4.68727 3.89905 5.9934Z"
        fill="#8BB5C3"
      />
    </svg>
  );
};

export default Union;

Union.propTypes = {
  svgId: PropTypes.string
};

Union.defaultProps = {
  svgId: null
};
